import React, { useState } from "react"
import styles from "./RoomItem.module.css"
import { FiEdit2, FiX } from "react-icons/fi"
import { RxCross1 } from "react-icons/rx"
import WindowItem from "../WindowItem/WindowItem"
import ProductItem from "../ProductItem/ProductItem"

const RoomItem = ({ room }) => {

    const getProductImage = product => {
        const colorway = product.selection_id?.product_id?.colorways?.[0]
        if (colorway?.images?.[0]?.url) {
            return colorway.images[0].url
        }
        return null
    }

    return (
        <>
            <div className={`my-3 ${styles.roomCard}`}>
                {/* Room Header */}
                <div
                    className={`d-flex justify-content-between align-items-center w-100 p-3`}
                >
                    <div className={styles.roomInfo}>
                        Room:<h3 className={styles.roomName}>{room.name}</h3>
                    </div>
                </div>

                <span className={styles.roomDivider}></span>

                {/* Room Products Section */}
                <div className={`w-100 text-start ${styles.roomProductsSection}`}>

                    {/* Windows Section */}
                    {room.windows && room.windows.length > 0 && (
                        <div className={`w-100 ${styles.windowsSubSection}`}>
                            {room.windows.map((window, windowIndex) => (
                                <WindowItem
                                    key={windowIndex}
                                    window={window}
                                    getProductImage={getProductImage}
                                />
                            ))}
                        </div>
                    )}

                    {/* Direct Products in Room (not in windows) */}
                    {room.products && room.products.length > 0 && (
                        <div className={styles.productsSubSection}>
                            <div className={styles.subSectionHeader}>
                                <h4>Products</h4>
                            </div>
                            <div className={styles.productsList}>
                                {room.products.map((product, productIndex) => {
                                    const productData = product.selection_id?.product_id
                                    const userSelection = product.selection_id?.userSelection
                                    const imageUrl = getProductImage(product)

                                    return (
                                        <ProductItem
                                            key={productIndex}
                                            product={product}
                                            productData={productData}
                                            userSelection={userSelection}
                                            imageUrl={imageUrl}
                                        />
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default RoomItem
